// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZMPbF","questions":"styles_questions__HU0IU","footer":"styles_footer__3sSl6"};